// ADDED BY @OPTIEXERTS
// FILE TO HANDLE THE JAVASCRIPT OF THE ADDED FEATURES
// {% comment %} CRO FILE UPDATED FROM UPDATED THEME {% endcomment %}

// FILE TO MOVE

let containerHTML = "";
let containerBlock = document.querySelector("#lazyload-container");

function buttonsClickHandler() {
    let tabsButtons = document.querySelectorAll(".tab-btn")
    let tabsContent = document.querySelectorAll(".text-content");

    if (tabsButtons && tabsContent) {
        tabsButtons.forEach((button, index) => {
            button.addEventListener("click", () => {

                const currentWrapper = document.querySelectorAll(".grid-overflow-wrapper-custom")[index];
                if (currentWrapper) {
                    const scrollRightBtn = currentWrapper.querySelector(".scroll-btn-right");
                    scrollRightBtn?.removeAttribute("disabled");
                }

                tabsButtons.forEach(btn => btn.classList.remove("btn-active"))
                tabsContent.forEach(tab => tab.classList.remove("tab-active"));
                tabsButtons[index].classList.add("btn-active");
                tabsContent[button.dataset.tabid].classList.add("tab-active");
                const element = document.querySelector(".collection-tabs-section");
                const offset = 160;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: elementPosition,
                    behavior: "smooth"
                });
                let shopHeaderContainer = document.querySelector(".shopify-section-header-sticky");
                setTimeout(() => {
                    if (!shopHeaderContainer.classList.contains("site-header--stuck")) {
                        document.querySelector(".tabs-buttons").classList.remove("buttons-sticky");
                    } else {
                        document.querySelector(".tabs-buttons").classList.add("buttons-sticky");
                        document.querySelector(".tabs-buttons").style.top = `${shopHeaderContainer.offsetHeight}px`;
                    }
                }, 400)

                const scrollableDiv = document.querySelectorAll(".custom-tabs-collection-inner")[index];
                let childrenDivs = scrollableDiv.querySelectorAll(".custom-collection-tabs-wrapper");
                setTimeout(() => {
                    let childrenWidth = childrenDivs[0].clientWidth * childrenDivs.length;
                    let arrowButtons = currentWrapper.querySelectorAll(".scroll-btn");
                    if (childrenWidth < scrollableDiv.clientWidth) {
                        arrowButtons.forEach(button => {
                            button.style.display = "none";
                        })
                    } else {
                        arrowButtons.forEach(button => {
                            button.style.display = "block";
                        })
                    }
                }, 500);

            });
        });
    }

}

buttonsClickHandler();
















let buttonsBlock = document.querySelector(".tabs-buttons");
let getRect = buttonsBlock ? buttonsBlock.getBoundingClientRect().top + window.scrollY : '';
var lastScrollTop = 0;
let addtocartButtonContainer = document.querySelector(".product-page-container");
let checkContainer = document.querySelector("#lazyload-container");
let stickycartContainer = document.querySelector(".sticky-button-container");
let footerContainer = document.querySelector("footer");
let stickyBackToTopButton = document.querySelector(".sticky-home-button");
let shopHeaderContainer = document.querySelector(".shopify-section-header-sticky");
window.addEventListener("scroll", function () {
    if (buttonsBlock) {
        var st = window.scrollY || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            if (window.scrollY > getRect) {
                buttonsBlock.classList.add("buttons-sticky");
                if (shopHeaderContainer && shopHeaderContainer.classList.contains("site-header--stuck")) {
                    buttonsBlock.style.top = `${shopHeaderContainer.offsetHeight}px`;
                } else {
                    buttonsBlock.style.top = "-1px";
                }
            } else {
                buttonsBlock.classList.remove("buttons-sticky");
            }
        } else if (st < lastScrollTop) {
            if (window.scrollY > getRect) {
                buttonsBlock.classList.add("buttons-sticky");
                if (shopHeaderContainer && shopHeaderContainer.classList.contains("site-header--stuck")) {
                    buttonsBlock.style.top = `${shopHeaderContainer.offsetHeight}px`;
                }
            } else {
                buttonsBlock.classList.remove("buttons-sticky");
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
        if (checkContainer.getBoundingClientRect().bottom < 100) {
            buttonsBlock.style.display = "none";
        } else {
            buttonsBlock.style.display = "flex";
        }
    }
    if (addtocartButtonContainer) {
        const footerRect = footerContainer.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        let cartButton = addtocartButtonContainer.querySelector("[id^='ProductSubmitButton-template']");
        if (cartButton) {
            if (cartButton.getBoundingClientRect().bottom < 0) {
                if (footerRect.top <= windowHeight && footerRect.bottom >= 0) {
                    stickycartContainer.classList.remove("activate-sticky");
                } else {
                    stickycartContainer.classList.add("activate-sticky");
                }
            } else {
                stickycartContainer.classList.remove("activate-sticky");
            }
        }
    }
    if (stickyBackToTopButton) {
        if (window.scrollY > 100) {
            stickyBackToTopButton.classList.add("activetopbutton");
        } else {
            stickyBackToTopButton.classList.remove("activetopbutton");
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    let buttonTracker = document.querySelectorAll(".stack_button_tracker")
    buttonTracker.forEach(button => {
        button.addEventListener("mouseup", function () {
            setTimeout(() => {
                fetch(window.location.origin + "?sections=cart-icon-bubble", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        let counterBubble = document.querySelector("#cart-icon-bubble");
                        if (counterBubble && data["cart-icon-bubble"]) {
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(data["cart-icon-bubble"], "text/html");
                            let itemSelector = doc.querySelector(".cart-count-bubble");

                            if (itemSelector) {
                                if (counterBubble.querySelector(".cart-count-bubble")) {
                                    counterBubble.querySelector(".cart-count-bubble").innerHTML = itemSelector.innerHTML;
                                } else {
                                    counterBubble.appendChild(itemSelector);
                                }
                            }
                        }
                    })
                    .catch(error => console.log("Error fetching cart bubble:", error));
            }, 1000);
        })
    })
})